import BaseService from '../BaseService.js'

export default class StammdatenService extends BaseService {

  constructor() {
    super('stammdaten')
  }

  async getBilanzzonen() {
    return this.list('bilanz-zonen')
  }

}
